(() => {
  // app/scripts/dropdown-component.js
  var DropdownComponent = class extends HTMLElement {
    constructor() {
      super();
      this._onDocClick = (e) => this._handleOutsideClick(e);
      this._onListClick = (e) => this._handleListClick(e);
    }
    connectedCallback() {
      this.triggerEl = this.querySelector(".js-btn");
      this.listEl = this.querySelector(".trigger__list");
      if (this.triggerEl && !this._triggerBound) {
        this._triggerBound = true;
        this.triggerEl.addEventListener("click", (e) => {
          e.stopPropagation();
          this.classList.contains("is-open") ? this.close() : this.open();
        });
      }
    }
    disconnectedCallback() {
      this.close();
    }
    open() {
      if (this.classList.contains("is-open")) return;
      this.classList.add("is-open");
      this.setAttribute("open", "");
      document.addEventListener("click", this._onDocClick);
      if (this.listEl) this.listEl.addEventListener("click", this._onListClick);
    }
    close() {
      if (!this.classList.contains("is-open")) return;
      this.classList.remove("is-open");
      this.removeAttribute("open");
      document.removeEventListener("click", this._onDocClick);
      if (this.listEl) this.listEl.removeEventListener("click", this._onListClick);
    }
    _handleOutsideClick(evt) {
      const clickedInside = this.contains(evt.target);
      if (!clickedInside) this.close();
    }
    _handleListClick(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      const item = evt.target.closest(".js-dropdown-item");
      if (!item) return;
      const all = this.listEl ? this.listEl.querySelectorAll(".js-dropdown-item") : [];
      all.forEach((el) => el.classList.remove("is-selected"));
      item.classList.add("is-selected");
      const labelEl = this.triggerEl && this.triggerEl.querySelector(".js-selected");
      if (labelEl) labelEl.textContent = item.getAttribute("data-label") || item.textContent.trim();
      const id = item.dataset.id;
      if (id) {
        const bundle = this.closest(".bundle-item");
        const input = bundle ? bundle.querySelector("input") : null;
        if (input) {
          input.id = `input${id}`;
          input.value = id;
        }
      }
      this.close();
    }
  };
  function defineDropdownComponent() {
    if (!window.customElements.get("dropdown-comp")) {
      customElements.define("dropdown-comp", DropdownComponent);
      console.log("[dropdown-comp] defined");
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", defineDropdownComponent, { once: true });
  } else {
    defineDropdownComponent();
  }
})();
